export const formatHeat = (value: number): string => {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)} 万`;
  }
  return `${value}`;
};

export default formatHeat;